'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.963 2.339a.535.535 0 0 1 .997 0l1.31 3.32a.536.536 0 0 0 .301.302l3.32 1.31a.535.535 0 0 1 0 .996l-3.32 1.31a.536.536 0 0 0-.302.302l-1.31 3.32a.535.535 0 0 1-.996 0l-1.31-3.32a.535.535 0 0 0-.3-.302L5.03 8.267a.535.535 0 0 1 0-.996l3.321-1.31a.535.535 0 0 0 .302-.301l1.31-3.321ZM16.701 9.896a.321.321 0 0 1 .598 0l.786 1.992a.321.321 0 0 0 .18.181l1.993.786a.321.321 0 0 1 0 .598l-1.992.786a.321.321 0 0 0-.181.18l-.786 1.993a.321.321 0 0 1-.598 0l-.786-1.992a.322.322 0 0 0-.18-.181l-1.993-.786a.321.321 0 0 1 0-.598l1.992-.786a.322.322 0 0 0 .181-.18l.786-1.993ZM8.134 13.787a.393.393 0 0 0-.73 0l-.96 2.435a.393.393 0 0 1-.222.221l-2.435.961a.393.393 0 0 0 0 .73l2.435.961c.101.04.182.12.221.221l.96 2.435c.132.332.6.332.731 0l.96-2.435a.393.393 0 0 1 .222-.221l2.435-.96a.393.393 0 0 0 0-.731l-2.435-.96a.393.393 0 0 1-.221-.222l-.96-2.435Z",
    fill: "currentColor"
  }));
});
var PremiumStars = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.PremiumStars = PremiumStars;